import React from 'react'
import "./DashbaordSelect.css";
function DashboardSelect() {
    return (
        <div className='select'>
            <div className='toppadding'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="contentsidesec w-100 pt-3">
                                <a href='/DashboardBOT'>
                                    <div className="card bg_2image">
                                        <div className="card-body mt-4">
                                            <div className="invoice-content1 mt-5 ps ps--active-y mt-4">
                                                <i className="fa fa-star tra ms-auto d-flex align-items-center justify-content-end" />
                                                <h3 className='mt-5 text-white text-end'>
                                                    MAGIC PLAN
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="contentsidesec  w-100 pt-3">
                                <a href='/DashboardFIX'>
                                    <div className="card cardsss  cardes">
                                        <div className="card-body mt-4">
                                            <div className="invoice-content1 mt-5 ps ps--active-y mt-4">
                                                <i className="fa fa-star tra" />
                                                <h3 className='mt-5 text-white'>
                                                    FIX PLAN
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardSelect